import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function TopBar() {
    const [rolename, setRoleName] = useState('');
    const [fullName, setfullName] = useState('');
   useEffect(() => {
      const role = localStorage.getItem("roleName");
      setRoleName(role);
      
      const name = localStorage.getItem("name");
      setfullName(name);
      
    }, []);
  const LogoutUser = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  return (
    <div class="header sticky-header">
      <div class="menu-right">
        <div class="navbar user-panel-top">
          {/* <div class="search-box">
            <form action="#search-results.html" method="get">
              <input
                class="search-input"
                placeholder="Search Here..."
                type="search"
                id="search"
              />
              <button class="search-submit" value="">
                <span class="fa fa-search"></span>
              </button>
            </form>
          </div> */}
          <div class="user-dropdown-details d-flex">
            <div class="profile_details_left">
              <ul class="nofitications-dropdown">
                <li class="dropdown">
                  <a
                    href="/"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa fa-bell-o"></i>
                    {/* <span class="badge blue">3</span> */}
                  </a>
                  {/* <ul class="dropdown-menu">
                    <li>
                      <div class="notification_header">
                        <h3>You have 3 new notifications</h3>
                      </div>
                    </li>
                    <li>
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar1.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>Johnson purchased template</p>
                          <span>Just Now</span>
                        </div>
                      </a>
                    </li>
                    <li class="odd">
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar2.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>New customer registered </p>
                          <span>1 hour ago</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar3.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>Lorem ipsum dolor sit amet </p>
                          <span>2 hours ago</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <div class="notification_bottom">
                        <a href="#all" class="bg-primary">
                          See all notifications
                        </a>
                      </div>
                    </li>
                  </ul> */}
                </li>
                <li class="dropdown">
                  <a
                    href="/"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa fa-comment-o"></i>
                    {/* <span class="badge blue">4</span> */}
                  </a>
                  {/* <ul class="dropdown-menu">
                    <li>
                      <div class="notification_header">
                        <h3>You have 4 new messages</h3>
                      </div>
                    </li>
                    <li>
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar1.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>Johnson purchased template</p>
                          <span>Just Now</span>
                        </div>
                      </a>
                    </li>
                    <li class="odd">
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar2.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>New customer registered </p>
                          <span>1 hour ago</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar3.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>Lorem ipsum dolor sit amet </p>
                          <span>2 hours ago</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="grid">
                        <div class="user_img">
                          <img src="assets/images/avatar1.jpg" alt="" />
                        </div>
                        <div class="notification_desc">
                          <p>Johnson purchased template</p>
                          <span>Just Now</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <div class="notification_bottom">
                        <a href="#all" class="bg-primary">
                          See all messages
                        </a>
                      </div>
                    </li>
                  </ul> */}
                </li>
              </ul>
            </div>
            <div class="profile_details">
              <ul>
                <li class="dropdown profile_details_drop">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    id="dropdownMenu3"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div class="profile_img">
                      <img
                        src="assets/images/woman.png"
                        class="rounded-circle"
                        alt=""
                      />
                      <div class="user-active">
                        <span></span>
                      </div>
                    </div>
                  </a>
                  <ul
                    class="dropdown-menu drp-mnu"
                    aria-labelledby="dropdownMenu3"
                  >
                    <li class="user-info">
                      <h5 class="user-name">{fullName}</h5>
                      <span class="status ml-2">{rolename} - Available</span>
                    </li>
                    {/* <li>
                      {" "}
                      <a href="#">
                        <i class="lnr lnr-user"></i>My Profile
                      </a>{" "}
                    </li> */}
                    {/* <li>
                      {" "}
                      <a href="#">
                        <i class="lnr lnr-users"></i>1k Followers
                      </a>{" "}
                    </li> */}
                    {/* <li>
                      {" "}
                      <a href="#">
                        <i class="lnr lnr-cog"></i>Setting
                      </a>{" "}
                    </li> */}
                    {/* <li>
                      {" "}
                      <a href="#">
                        <i class="lnr lnr-heart"></i>100 Likes
                      </a>{" "}
                    </li> */}
                    <li class="logout py-2">
                      {" "}
                      <span
                        href="#sign-up.html"
                        onClick={LogoutUser}
                        className="ml-3"
                        style={{ cursor: "pointer" }}
                      >
                        <i class="fa fa-power-off"></i> Logout
                      </span>{" "}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
